<!-- 意见收集统计（固定收集表） -->
<template>
  <el-container class="home-container">
    <el-header>
      <div>
        <span>畅游景德镇管理系统</span>
      </div>
      <h6>{{ userName }}, 你好</h6>
      <el-button type="info" @click="logout">退出</el-button>
    </el-header>
    <el-main>
      <div class="suggestion-stats">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>首页</el-breadcrumb-item>
          <el-breadcrumb-item>意见收集统计</el-breadcrumb-item>
        </el-breadcrumb>

        <el-card class="main-card">
          <el-row :gutter="20" class="page-header">
            <el-col :span="14">
              <span class="page-title">意见收集统计</span>
              <span class="page-id">收集表ID：{{ questionnaireId }}</span>
            </el-col>
            <el-col :span="10" class="page-actions">
              <el-button icon="el-icon-refresh" @click="handleRefresh">刷新</el-button>
            </el-col>
          </el-row>

          <el-tabs v-model="activeTab" style="margin-top: 20px" @tab-click="handleTabClick">
            <el-tab-pane label="收集统计" name="summary">
              <div v-loading="summaryLoading">
                <template v-if="summary">
                  <div class="summary-header">
                    <h3>{{ summary.title || '意见收集统计' }}</h3>
                    <p class="summary-meta">
                      收集表ID：{{ summary.questionnaireId || questionnaireId }}
                      <span class="summary-divider">|</span>
                      提交总数：<strong>{{ summary.totalSubmissions || 0 }}</strong>
                    </p>
                  </div>

                  <div
                    v-for="(question, index) in summary.questionStats || []"
                    :key="question.questionId"
                    class="question-block"
                  >
                    <div class="question-title">
                      <span class="question-index">第 {{ index + 1 }} 项</span>
                      <el-tag size="mini" type="info">{{ formatQuestionType(question.type) }}</el-tag>
                    </div>
                    <p class="question-content">{{ question.content }}</p>
                    <p class="question-counts">
                      填写数量：{{ question.answerCount || 0 }}
                      <span class="summary-divider">|</span>
                      未填写：{{ question.skipCount || 0 }}
                    </p>

                    <el-table
                      v-if="question.optionStats && question.optionStats.length"
                      :data="question.optionStats"
                      border
                      stripe
                      size="small"
                      style="margin-top: 12px"
                    >
                      <el-table-column label="选项" width="80" prop="label"></el-table-column>
                      <el-table-column label="内容" prop="content" min-width="200"></el-table-column>
                      <el-table-column label="人数" width="90" prop="count"></el-table-column>
                      <el-table-column label="占比" width="100">
                        <template v-slot:default="scope">
                          {{ formatPercentage(scope.row.percentage) }}
                        </template>
                      </el-table-column>
                      <el-table-column label="补充说明" min-width="160">
                        <template v-slot:default="scope">
                          {{ formatSupplementalTexts(scope.row.supplementalTexts) }}
                        </template>
                      </el-table-column>
                    </el-table>

                    <el-table
                      v-else-if="question.textAnswerStats && question.textAnswerStats.length"
                      :data="question.textAnswerStats"
                      border
                      stripe
                      size="small"
                      style="margin-top: 12px"
                    >
                      <el-table-column label="答案内容" min-width="260">
                        <template v-slot:default="scope">
                          {{ scope.row.text || scope.row.answer || scope.row.content || '-' }}
                        </template>
                      </el-table-column>
                      <el-table-column label="重复次数" width="120">
                        <template v-slot:default="scope">
                          {{ scope.row.count != null ? scope.row.count : '-' }}
                        </template>
                      </el-table-column>
                    </el-table>

                    <el-empty
                      v-else
                      description="暂无统计内容"
                      :image-size="60"
                    ></el-empty>
                  </div>

                  <el-empty
                    v-if="!(summary.questionStats && summary.questionStats.length)"
                    description="暂无收集项统计"
                  ></el-empty>
                </template>
                <el-empty v-else description="暂无统计内容"></el-empty>
              </div>
            </el-tab-pane>

            <el-tab-pane label="提交列表" name="list">
              <el-row :gutter="20" class="list-filters">
                <el-col :span="6">
                  <el-input
                    placeholder="会员ID（可选）"
                    v-model="listQuery.memberId"
                    clearable
                  ></el-input>
                </el-col>
                <el-col :span="6">
                  <el-date-picker
                    v-model="listQuery.startTime"
                    type="date"
                    placeholder="开始日期（可选）"
                    style="width: 100%"
                  ></el-date-picker>
                </el-col>
                <el-col :span="6">
                  <el-date-picker
                    v-model="listQuery.endTime"
                    type="date"
                    placeholder="结束日期（可选）"
                    style="width: 100%"
                  ></el-date-picker>
                </el-col>
                <el-col :span="4">
                  <el-button type="primary" icon="el-icon-search" @click="searchList">查询</el-button>
                </el-col>
              </el-row>

              <el-table
                :data="answerList"
                border
                stripe
                v-loading="listLoading"
                style="margin-top: 20px"
              >
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column label="姓名" min-width="100">
                  <template v-slot:default="scope">
                    {{ getName(scope.row) }}
                  </template>
                </el-table-column>
                <el-table-column label="手机号" min-width="120">
                  <template v-slot:default="scope">
                    {{ getPhone(scope.row) }}
                  </template>
                </el-table-column>
                <el-table-column label="内容摘要" min-width="220">
                  <template v-slot:default="scope">
                    <div class="answer-brief">
                      <div
                        v-for="(item, index) in getAnswerBrief(scope.row)"
                        :key="index"
                        class="answer-brief-item"
                      >
                        <span class="answer-brief-label">{{ item.label }}：</span>
                        <span class="answer-brief-value">{{ item.value }}</span>
                      </div>
                      <span v-if="!getAnswerBrief(scope.row).length">-</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="提交时间" min-width="160">
                  <template v-slot:default="scope">
                    {{ formatSubmitTime(scope.row.submitTime) }}
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="100">
                  <template v-slot:default="scope">
                    <el-button type="text" size="small" @click="showAnswers(scope.row)">查看内容</el-button>
                  </template>
                </el-table-column>
              </el-table>

              <el-pagination
                style="margin-top: 20px"
                @current-change="handlePageChange"
                :current-page="listQuery.page"
                :page-size="listQuery.pageSize"
                layout="total, prev, pager, next, jumper"
                :total="listTotal"
              ></el-pagination>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </div>
    </el-main>

    <el-dialog title="意见详情" :visible.sync="answersDialogVisible" width="720px">
      <div v-if="answerDetail.length" class="answer-detail">
        <div v-for="(item, index) in answerDetail" :key="index" class="answer-item">
          <div class="answer-question">
            <span class="answer-index">第 {{ index + 1 }} 项</span>
            <span class="answer-title">{{ item.questionContent || item.questionId || '未命名项' }}</span>
          </div>
          <div class="answer-value">
            <template v-if="item.options.length">
              <el-tag
                v-for="(opt, i) in item.options"
                :key="i"
                size="small"
                type="success"
                class="answer-tag"
              >{{ opt }}</el-tag>
            </template>
            <div v-else-if="item.attachments.length" class="answer-attachments">
              <div v-for="(url, i) in item.attachments" :key="i" class="answer-attachment">
                <el-image
                  v-if="isImageUrl(url)"
                  :src="url"
                  :preview-src-list="item.attachments"
                  fit="cover"
                  class="answer-image"
                >
                  <div slot="error" class="answer-image-error">
                    <el-link :href="url" target="_blank" type="primary">打开附件</el-link>
                  </div>
                </el-image>
                <el-link v-else :href="url" target="_blank" type="primary" class="answer-link">
                  {{ shortUrl(url) }}
                </el-link>
              </div>
            </div>
            <span v-else class="answer-text">{{ item.text || '-' }}</span>
          </div>
        </div>
      </div>
      <el-empty v-else description="暂无填写内容" :image-size="60"></el-empty>

      <div class="answer-raw">
        <el-button type="text" size="small" @click="showRawAnswers = !showRawAnswers">
          {{ showRawAnswers ? '收起原始数据' : '查看原始数据' }}
        </el-button>
        <pre v-if="showRawAnswers" class="answers-json">{{ formattedAnswers }}</pre>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import DateFormat from '@/utils/DateFormat.js'

// 固定收集表ID：意见收集
const FIXED_QUESTIONNAIRE_ID = '3a76d910-2041-4807-9bc4-ee6b08f0b66f'
const IMAGE_EXT_REG = /\.(png|jpe?g|gif|webp|bmp|svg)(\?.*)?$/i

export default {
  data() {
    return {
      activeTab: 'summary',
      questionnaireId: FIXED_QUESTIONNAIRE_ID,
      summary: null,
      summaryLoading: false,
      answerList: [],
      listLoading: false,
      listTotal: 0,
      listQuery: {
        memberId: '',
        startTime: '',
        endTime: '',
        page: 1,
        pageSize: 20,
      },
      answersDialogVisible: false,
      formattedAnswers: '',
      answerDetail: [],
      showRawAnswers: false,
      userName: window.sessionStorage.getItem('userName') || '',
    }
  },
  created() {
    window.sessionStorage.setItem('activePath', this.$route.path || '/suggestionStats')
    this.loadSummary()
  },
  methods: {
    logout() {
      window.localStorage.clear()
      this.$router.push('/').catch(() => {})
    },
    formatQuestionType(type) {
      const map = {
        single: '单选项',
        multiple: '多选项',
        text: '文本项',
      }
      return map[type] || type || '未分类'
    },
    formatPercentage(val) {
      if (val == null || val === '') return '-'
      return `${Number(val).toFixed(2)}%`
    },
    formatSupplementalTexts(texts) {
      if (!texts || !texts.length) return '-'
      return texts.join('、')
    },
    formatSubmitTime(time) {
      if (!time) return '-'
      const date = new Date(time)
      if (Number.isNaN(date.getTime())) return time
      return new DateFormat(date).toString('yyyy-0m-0d 0h:0f:0s')
    },
    formatAnonymous(val) {
      if (val == null || String(val).trim() === '') return '匿名'
      return val
    },
    handleRefresh() {
      if (this.activeTab === 'summary') {
        this.loadSummary()
      } else {
        this.loadAnswerList()
      }
    },
    handleTabClick(tab) {
      if (tab.name === 'summary' && !this.summary) {
        this.loadSummary()
      }
      if (tab.name === 'list' && !this.answerList.length) {
        this.loadAnswerList()
      }
    },
    loadSummary() {
      this.summaryLoading = true
      this.$axios({
        method: 'get',
        url: `/manager/questionnaireAnswerSummary?questionnaireId=${encodeURIComponent(this.questionnaireId)}`,
      })
        .then((res) => {
          if (res.code === 200) {
            this.summary = res.data || null
            if (!this.summary) {
              this.$message.info('未查询到统计数据')
            }
          } else {
            this.$message.warning(res.msg)
          }
        })
        .catch((err) => err)
        .finally(() => {
          this.summaryLoading = false
        })
    },
    searchList() {
      this.listQuery.page = 1
      this.loadAnswerList()
    },
    buildListParams() {
      const params = {
        questionnaireId: this.questionnaireId,
        page: this.listQuery.page,
        pageSize: this.listQuery.pageSize,
      }
      const memberId = this.listQuery.memberId && String(this.listQuery.memberId).trim()
      if (memberId) {
        params.memberId = memberId
      }
      if (this.listQuery.startTime) {
        params.startTime = new DateFormat(new Date(this.listQuery.startTime)).toString('yyyy-0m-0d')
      }
      if (this.listQuery.endTime) {
        params.endTime = new DateFormat(new Date(this.listQuery.endTime)).toString('yyyy-0m-0d')
      }
      return params
    },
    buildListQueryString(params) {
      return Object.keys(params)
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&')
    },
    loadAnswerList() {
      this.listLoading = true
      this.$axios({
        method: 'get',
        url: `/manager/questionnaireAnswerList?${this.buildListQueryString(this.buildListParams())}`,
      })
        .then((res) => {
          if (res.code === 200) {
            this.answerList = (res.data || []).map((item) => ({
              ...item,
              _parsedAnswers: this.parseAnswers(item.answers),
            }))
            this.listTotal = res.total || 0
            if (!this.answerList.length) {
              this.$message.info('未查询到提交记录')
            }
          } else {
            this.$message.warning(res.msg)
          }
        })
        .catch((err) => err)
        .finally(() => {
          this.listLoading = false
        })
    },
    handlePageChange(page) {
      this.listQuery.page = page
      this.loadAnswerList()
    },
    // 把原始答案（对象/JSON字符串）解析成统一结构
    parseAnswers(answers) {
      let list = answers
      if (answers == null || answers === '') return []
      if (typeof answers === 'string') {
        try {
          list = JSON.parse(answers)
        } catch (e) {
          return [
            {
              questionId: '',
              questionContent: '',
              kind: 'text',
              options: [],
              attachments: [],
              text: answers,
            },
          ]
        }
      }
      if (!Array.isArray(list)) list = [list]

      return list.map((item) => {
        const raw = item || {}
        const options = this.buildOptions(raw)
        // 兼容两种结构：
        // 1) { questionId, questionContent, optionIds, optionLabels, optionContents, textAnswer }
        // 2) { question, answer }
        const rawAnswer = raw.answer != null ? raw.answer : (raw.textAnswer != null ? raw.textAnswer : '')
        const attachments = this.extractAttachments(rawAnswer)
        const text = attachments.length
          ? ''
          : (Array.isArray(rawAnswer) ? rawAnswer.join('、') : (rawAnswer == null ? '' : String(rawAnswer)))
        let kind = 'text'
        if (options.length) kind = 'option'
        if (attachments.length) kind = 'attachment'
        return {
          questionId: raw.questionId || '',
          questionContent: raw.question || raw.questionContent || raw.content || '',
          kind,
          options,
          attachments,
          text,
        }
      })
    },
    // 选项：标签 + 内容，如 "A. 工作流程"
    buildOptions(raw) {
      const labels = raw.optionLabels || []
      const contents = raw.optionContents || []
      const rawOptions = raw.optionTexts || raw.options || []
      const size = Math.max(contents.length, labels.length)
      const result = []
      for (let i = 0; i < size; i += 1) {
        const label = labels[i] != null && String(labels[i]).trim() !== '' ? `${labels[i]}. ` : ''
        const content = contents[i] != null ? String(contents[i]) : ''
        const value = `${label}${content}`.trim()
        if (value) result.push(value)
      }
      if (!result.length && Array.isArray(rawOptions)) {
        rawOptions.forEach((opt) => {
          if (opt == null) return
          if (typeof opt === 'string') {
            if (opt.trim()) result.push(opt.trim())
          } else {
            const label = opt.label ? `${opt.label}. ` : ''
            const content = opt.content != null ? String(opt.content) : ''
            const value = `${label}${content}`.trim()
            if (value) result.push(value)
          }
        })
      }
      return result
    },
    // 附件：answer 可能是单个 URL、URL 数组或 JSON 数组字符串（图片/文件地址）
    extractAttachments(answer) {
      if (!answer) return []
      let values = []
      if (Array.isArray(answer)) {
        values = answer
      } else if (typeof answer === 'string') {
        const trimmed = answer.trim()
        if (trimmed.startsWith('[') || trimmed.startsWith('{')) {
          try {
            const parsed = JSON.parse(trimmed)
            values = Array.isArray(parsed) ? parsed : [parsed]
          } catch (e) {
            return []
          }
        } else if (/^https?:\/\//i.test(trimmed)) {
          // 多图/多附件：以「、」、逗号、分号或空白分隔
          values = trimmed.split(/[\s、,，;；]+/)
        } else {
          return []
        }
      } else {
        values = [answer]
      }
      return values
        .map((val) => {
          if (val == null) return ''
          if (typeof val === 'string') return val.trim()
          return String(val.url || val.link || val.path || val.fileUrl || '').trim()
        })
        .filter((val) => /^https?:\/\//i.test(val))
    },
    isImageUrl(url) {
      if (!url) return false
      return IMAGE_EXT_REG.test(url.split('?')[0])
    },
    shortUrl(url) {
      if (!url) return '-'
      if (url.length <= 40) return url
      return `${url.slice(0, 24)}...${url.slice(-12)}`
    },
    // 列表里的内容摘要：选项类显示选项，附件显示数量，文本类显示内容
    getAnswerBrief(row) {
      const parsed = row._parsedAnswers || this.parseAnswers(row.answers)
      return parsed
        .filter((item) => item.questionContent)
        .map((item) => {
          let value = '-'
          if (item.options.length) {
            value = item.options.join('、')
          } else if (item.attachments.length) {
            value = `${item.attachments.length} 个附件`
          } else if (item.text) {
            value = item.text.length > 30 ? `${item.text.slice(0, 30)}...` : item.text
          }
          return { label: item.questionContent, value }
        })
    },
    // 按收集项取值：优先匹配 questionId（q5/q6），其次按题目内容关键字
    findAnswerValue(row, ids, keywords) {
      const parsed = row._parsedAnswers || this.parseAnswers(row.answers)
      const match = parsed.find((item) => {
        const qid = item.questionId ? String(item.questionId).toLowerCase() : ''
        if (qid && ids.includes(qid)) return true
        return keywords.some((kw) => (item.questionContent || '').includes(kw))
      })
      if (!match) return ''
      if (match.options.length) return match.options.join('、')
      return match.text || ''
    },
    // 姓名取自第5项，取不到（如选择匿名）则显示“匿名”
    getName(row) {
      return this.findAnswerValue(row, ['q5'], ['姓名']) || this.formatAnonymous(row.nickname)
    },
    // 手机号取自第6项，取不到（如选择匿名）则显示“匿名”
    getPhone(row) {
      return (
        this.findAnswerValue(row, ['q6'], ['手机号', '联系电话', '电话', '联系方式']) ||
        this.formatAnonymous(row.phone)
      )
    },
    showAnswers(row) {
      this.answerDetail = row._parsedAnswers || this.parseAnswers(row.answers)
      this.formattedAnswers = this.stringifyAnswers(row.answers)
      this.showRawAnswers = false
      this.answersDialogVisible = true
    },
    stringifyAnswers(answers) {
      if (answers == null) return '-'
      if (typeof answers === 'string') {
        try {
          return JSON.stringify(JSON.parse(answers), null, 2)
        } catch (e) {
          return answers
        }
      }
      return JSON.stringify(answers, null, 2)
    },
  },
}
</script>

<style scoped>
.suggestion-stats {
  padding: 8px;
}

.main-card {
  margin-top: 12px;
}

.page-header {
  display: flex;
  align-items: center;
}

.page-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  margin-right: 12px;
}

.page-id {
  color: #909399;
  font-size: 13px;
}

.page-actions {
  text-align: right;
}

.summary-header h3 {
  margin: 0 0 8px;
}

.summary-meta {
  margin: 0 0 20px;
  color: #606266;
}

.summary-divider {
  margin: 0 8px;
  color: #dcdfe6;
}

.question-block {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #ebeef5;
}

.question-block:last-child {
  border-bottom: none;
}

.question-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.question-index {
  font-weight: bold;
  color: #303133;
}

.question-content {
  margin: 0 0 8px;
  color: #303133;
  line-height: 1.6;
}

.question-counts {
  margin: 0;
  color: #909399;
  font-size: 13px;
}

.list-filters {
  margin-top: 4px;
}

.answer-brief {
  line-height: 1.6;
  font-size: 13px;
}

.answer-brief-item {
  color: #606266;
}

.answer-brief-label {
  color: #909399;
}

.answer-brief-value {
  color: #303133;
}

.answer-detail {
  max-height: 520px;
  overflow: auto;
}

.answer-item {
  padding: 10px 0;
  border-bottom: 1px solid #ebeef5;
}

.answer-item:last-child {
  border-bottom: none;
}

.answer-question {
  margin-bottom: 6px;
}

.answer-index {
  font-size: 12px;
  color: #909399;
  margin-right: 8px;
}

.answer-title {
  font-weight: bold;
  color: #303133;
}

.answer-value {
  color: #303133;
  line-height: 1.6;
  word-break: break-all;
}

.answer-tag {
  margin: 0 8px 4px 0;
}

.answer-text {
  white-space: pre-wrap;
}

.answer-attachments {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.answer-image {
  width: 100px;
  height: 100px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background: #f5f7fa;
}

.answer-image-error {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 12px;
}

.answer-link {
  font-size: 13px;
}

.answer-raw {
  margin-top: 12px;
}

.answers-json {
  margin: 0;
  max-height: 300px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-all;
  background: #f5f7fa;
  padding: 12px;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1.5;
}
</style>

<style>
.home-container {
  height: 100vh;
}
.el-header {
  background-color: #373d41;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  font-size: 24px;
  font-weight: bold;
}
.el-main {
  background-color: #eaedf1;
}
</style>
